import {useDispatch, useSelector} from "react-redux";
import {selectActiveOrganization} from "../../../../../app/store/reducers/auth/authReducer";
import React, {useEffect, useState} from "react";
import {loadDraftEmpowerment}      from "../../../../../app/store/reducers/roaming/roamingEmpowermentReducer";
import EmpowermentV2               from "../EmpowermentV2";
import {useHistory, useRouteMatch} from "react-router-dom";
import {VIEWER_CUSTOMER} from "../../../../../enum/EmpowermentStatus";
import checkPermission from "../../../../../enum/Permission/CheckPermission";
import {PermissionRoamingEmpowermentView} from "../../../../../enum/Permission/RoamingPermission";
import {selectAccountRolePermissions} from "../../../../../app/store/reducers/role/roleReducer";
import SpinnerComponent from "../../../spinner/SpinnerComponent";


const DraftEmpowermentV2 = ({modalId}) => {
    const [draftEmpowermentV2, setDraftEmpowermentV2] = useState(null)
    const [draftEmpowermentV2Json, setDraftEmpowermentV2Json] = useState(null)
    const activeOrganization = useSelector(selectActiveOrganization)
    const {params: {id}} = useRouteMatch();
    const history = useHistory()
    const dispatch = useDispatch()
    const permission = useSelector(selectAccountRolePermissions)

    useEffect(() => {
        if (permission.length && !dispatch(checkPermission(PermissionRoamingEmpowermentView))) {
            if (history.length > 1) {
                history.push('/roaming/empowerments-v2/draft')
            } else {
                history.push('/')
            }
        }
    }, [permission])

    useEffect(() => {
        loadEmpowermentV2()
    }, [modalId, id, activeOrganization])


    const loadEmpowermentV2 = async () => {
        try {
            const getDraft = await loadDraftEmpowerment(modalId ? modalId : id)
            setDraftEmpowermentV2(JSON.parse(getDraft?.data?.content))
            setDraftEmpowermentV2Json(getDraft?.data?.content)
        }catch (error) {
            history.push(`/roaming/empowerments-v2/${VIEWER_CUSTOMER}`)
        }
    }

    const empowermentV2 = {
        id: draftEmpowermentV2?.EmpowermentId,
        product_id: draftEmpowermentV2?.ProductList?.EmpowermentProductId,
        agent_empowerment_id: draftEmpowermentV2?.Agent?.AgentEmpowermentV2Id,
        info: {
            number: draftEmpowermentV2?.EmpowermentDoc?.EmpowermentNo,
            start: draftEmpowermentV2?.EmpowermentDoc?.EmpowermentDateOfIssue,
            end: draftEmpowermentV2?.EmpowermentDoc?.EmpowermentDateOfExpire,
        },
        customer: {
            inn: draftEmpowermentV2?.BuyerTin,
            name: draftEmpowermentV2?.Buyer?.Name,
            director: draftEmpowermentV2?.Buyer?.Director,
            accountant: draftEmpowermentV2?.Buyer?.Accountant,
        },
        executor: {
            inn: draftEmpowermentV2?.SellerTin,
            name: draftEmpowermentV2?.Seller?.Name,
            director: draftEmpowermentV2?.Seller?.Director,
            accountant: draftEmpowermentV2?.Seller?.Accountant,
        },
        person_info: {
            full_name: draftEmpowermentV2?.Agent?.Fio,
            person_inn: draftEmpowermentV2?.Agent?.AgentTin,
        },
        contract: {
            date: draftEmpowermentV2?.ContractDoc?.ContractDate,
            number: draftEmpowermentV2?.ContractDoc?.ContractNo,
        },
        items: draftEmpowermentV2?.ProductList?.Products.map(item => {
            return {
                ordering_number: item?.OrdNo,
                name: item?.Name,
                quantity: item?.Count,
                measure_id: item?.MeasureId,
                catalog: {
                    code: item?.CatalogCode,
                    name: item?.CatalogName,
                }
            }
        })
    }


    return (
        <>
            {draftEmpowermentV2 && <EmpowermentV2 modalId={modalId} empowermentV2={empowermentV2} draftEmpowermentV2Json={draftEmpowermentV2Json}/>}
            {!draftEmpowermentV2 && <SpinnerComponent />}
        </>
    )
}

export default DraftEmpowermentV2;
